module.exports = __webpack_public_path__ + "static/3-ba539b3f2b6af772087f98a81ec5b31a.png";